/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes,extraRequire}
 * tslint:disable
 */
var styles = [".spin-wrap-content[_ngcontent-%COMP%]{margin-top:25vh!important}.submit-exam[_ngcontent-%COMP%]   h5[_ngcontent-%COMP%]{font-size:18px}#exammessage[_ngcontent-%COMP%]{font-size:24px;line-height:35px}a.start_new_exm[_ngcontent-%COMP%]{font-size:18px;background:#337ab7;color:#fff;padding:10px;border-radius:3px;text-decoration:none}.card[_ngcontent-%COMP%]{margin-bottom:0;padding-bottom:15px}.complaint[_ngcontent-%COMP%]{font-family:inherit!important;font-weight:600!important;line-height:1.5!important;font-size:medium!important;cursor:pointer;color:#74bbf7!important}"];
export { styles as styles };

